import { render, staticRenderFns } from "./ItemGroups.vue?vue&type=template&id=e86437d6&"
import script from "./ItemGroups.vue?vue&type=script&lang=js&"
export * from "./ItemGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports